import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
    --checkbox-size: 24px;
    --checkbox-border: var(--sm-line, 1.5px) solid var(--color-primary-dark, #001d68);
    --checkbox-bg: var(--color-white, #ffffff);
    --checkbox-bg-checked: var(--color-secondary, #2594e3);
    --checkbox-bg-indeterminate: var(--color-primary-dark, #001d68);
    --checkbox-bg-disabled: var(--color-gray-3, #d7d4d2);
    --checkmark-color: var(--color-white, #ffffff);
    --label-color: var(--color-dark-gray-2, #030711);
    --label-color-disabled: var(--color-gray-6, #7c7c7c);
  }

  .checkbox-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-md, 16px);
    cursor: pointer;
    user-select: none;
  }

  :host([position="right"]) .checkbox-wrapper {
    flex-direction: row-reverse;
  }

  :host([disabled]) .checkbox-wrapper,
  .checkbox-wrapper[aria-disabled="true"] {
    cursor: not-allowed;
    opacity: 0.7;
  }

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .checkbox {
    width: var(--checkbox-size);
    height: var(--checkbox-size);
    border-radius: var(--radius-sm, 8px);
    box-sizing: border-box;
    position: relative;
    flex: none;
    background: var(--checkbox-bg);
    border: var(--checkbox-border);
    transition: all 0.2s ease-in-out;
  }

  .checkmark, .minus {
    position: absolute;
    top: 2px;
    left: 2px;
    width: calc(var(--checkbox-size) - 4px);
    height: calc(var(--checkbox-size) - 4px);
  }

  .minus {
    background: var(--checkmark-color);
    height: 2px;
    top: 50%;
    transform: translateY(-50%);
  }

  :host([state="default"]) .checkbox {
    border: var(--checkbox-border);
  }

  :host([state="hover"]) .checkbox {
    border-color: var(--color-secondary, #2594e3);
  }

  :host([state="focus"]) .checkbox {
    border-color: var(--color-secondary, #2594e3);
    box-shadow: 0 0 0 3px var(--shadow-focus, #c3d6e3);
  }

  :host([state="press"]) .checkbox {
    transform: scale(0.95);
  }

  :host([state="selected"]) .checkbox {
    background: var(--checkbox-bg-checked);
    border: none;
  }

  :host([state="indeterminate"]) .checkbox {
    background: var(--checkbox-bg-indeterminate);
    border: none;
  }

  :host([state="disabled"]) .checkbox {
    background: var(--checkbox-bg-disabled);
    border-color: var(--color-gray-3, #d7d4d2);
  }

  .label, ::slotted([slot="label"]) {
    font-size: var(--font-size-b1, 16px);
    line-height: var(--line-height-b1, 24px);
    font-weight: var(--font-weight-regular, 400);
    color: var(--label-color);
  }

  :host([position="right"]) .label,
  :host([position="right"]) ::slotted([slot="label"]) {
    text-align: right;
  }

  :host([state="disabled"]) .label,
  :host([state="disabled"]) ::slotted([slot="label"]) {
    color: var(--label-color-disabled);
  }
`;